import type { RefusedPublicationStorage } from '@streamlain/doc-publication-contract';

export function isRefusedPublicationStorage(
  storage: unknown
): storage is RefusedPublicationStorage {
  return (
    storage !== null &&
    typeof storage === 'object' &&
    typeof Reflect.get(storage, 'listRefusedPublications') === 'function' &&
    typeof Reflect.get(storage, 'resolveRefusedPublications') === 'function'
  );
}
